<div mat-dialog-title class="title d-flex bg-gray">
    <h5 class="mb-0 d-flex justify-content-start w-100 py-4">
        {{ "Send Email" | translate }}
    </h5>
    <button class="close-btn bg-transparent p-0 border-none" (click)="close()"><i class="flaticon-close"></i></button>
</div>
<form [formGroup]="email_form" (ngSubmit)="sendMail()">
    <mat-dialog-content class="py-4">
        <mat-card style="min-height: 400px;">
            <mat-card-content>
                <div class="tagus-form-group">
                    <mat-form-field appearance="fill">
                        <mat-label>Email Template</mat-label>
                        <i class="flaticon-email-3"></i>
                        <mat-select name="status" (selectionChange)="templateChange($event.value)">
                            <mat-option *ngFor="let subject of email_subject_list" [value]="subject?.emailTemplate?.id">
                                {{subject?.emailTemplate?.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <ng-container *ngIf="email_form.get('subject').value">
                    <div class="tagus-form-group without-icon">
                        <mat-form-field appearance="fill">
                            <mat-label>Subject</mat-label>
                            <input matInput formControlName="subject">
                        </mat-form-field>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12" *ngIf="subject_msg">
                        <div role="alert" class="alert alert-danger msg-cls" [innerHTML]="subject_msg">
                        </div>
                        <!-- <div role="alert" class="alert alert-danger msg-cls">{{subject_msg | specialChar}}</div> -->
                    </div>

                    <div class="tagus-form-group without-icon">
                        <mat-form-field appearance="fill">
                            <mat-label>From</mat-label>
                            <!-- <input matInput formControlName="from" readonly> -->
                            <mat-select name="status" formControlName="from">
                                <mat-option *ngFor="let from_mail of from_mail_list" [value]="from_mail">
                                    {{from_mail}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12"
                        *ngIf="email_form.get('from').hasError('required') && email_form.get('from').touched && email_form.value">
                        <div role="alert" class="alert alert-danger msg-cls">
                            Please select a sender email address.
                        </div>
                    </div>

                    <div class="tagus-form-group mb-20">
                        <mat-slide-toggle color="primary" formControlName="agentStatus">Notify
                            Agent</mat-slide-toggle>
                    </div>
                    
                    <div class="tagus-form-group without-icon" *ngIf="showBankDropdown">
                        <mat-form-field appearance="fill" class="w-100">
                          <mat-label>Select Bank Name</mat-label>
                          <mat-select [formControl]="bankNameControl" (selectionChange)="onBankNameChange($event)">
                            <ngx-mat-select-search
                              [formControl]="bankNameFilterCtrl"
                              placeholderLabel="Find Bank Name..."
                              noEntriesFoundLabel="No matching bank found"
                            ></ngx-mat-select-search>
                            <mat-option *ngFor="let bank of filteredBankList | async" [value]="bank">
                                {{ bank.bankName }}
                              </mat-option>
                          </mat-select>
                          <button
                            mat-icon-button
                            matSuffix
                            *ngIf="bankNameControl.value"
                            (click)="clearBankSelection(); $event.stopPropagation()"
                          >
                            <mat-icon>close</mat-icon>
                          </button>
                        </mat-form-field>
                      </div>

                      <div class="tagus-form-group without-icon "  *ngIf="showBankDropdown && zonalOfficeList.length > 0 && zonalOfficeList[0] !== null">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Select Zonal Office</mat-label>
                            <mat-select [(value)]="selectedZonalOffice" (selectionChange)="onZonalOfficeChange($event)">
                                <mat-option *ngFor="let zonalOffice of zonalOfficeList" [value]="zonalOffice">
                                    {{ zonalOffice }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                      
                    <span *ngIf="email_form.get('from').value">

                        <div class="d-flex to-mail-wrap mb-5">
                            <mat-chip-listbox>
                                <mat-chip *ngFor="let email of to_email_list; let i = index">
                                    {{email}}
                                    <button matChipRemove (click)="removeToEmail(i)">
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip>
                            </mat-chip-listbox>
                            <!-- <div role="alert" 
                                class="alert alert-dark d-flex 
                                    justify-content-space-between 
                                    align-items-center
                                    to-mail-div"
                                    >
                                     <span>
                                         {{email}}
                                     </span>
                                    <button type="button" 
                                        (click)="removeToEmail(i)" 
                                        aria-label="Close" 
                                        class="close bg-transparent p-0 border-none text-black note-btn" >
                                        <i class="ri-close-line"></i>
                                    </button>
                            </div> -->
                        </div>                       
                    <ng-container *ngIf="!showBankDropdown">
                        <div class="tagus-form-group without-icon">
                            <mat-form-field appearance="fill">
                                <mat-label>To</mat-label>
                                <input matInput formControlName="to" (keydown.enter)="addToEmail($event); false">
                                <mat-error *ngIf="email_form.get('to').hasError('email')">
                                    Invalid Email
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="showBankDropdown">
                        <div style="display: flex; align-items: baseline; gap: 10px;" class="tagus-form-group without-icon">
                            <!-- Username Field (60%) -->
                            <mat-form-field appearance="fill" style="flex: 0 0 60%;">
                                <mat-label>To (Username)</mat-label>
                                <input
                                    matInput
                                    [formControl]="toUsername"
                                    (keydown.enter)="addToEmail($event); $event.preventDefault()"
                                />
                                <!-- <mat-error *ngIf="toUsername.hasError('required') && is_submitted &&  to_email_list.length < 1">
                                    Username is required
                                </mat-error> -->
                            </mat-form-field>
                    
                            <!-- Domain Field (40%) -->
                            <mat-form-field appearance="fill" style="flex: 0 0 40%; min-width: 150px;">
                                <mat-label>Domain</mat-label>
                                <input matInput [value]="toDomain" disabled />
                            </mat-form-field>
                        </div>
                        <!-- <mat-error
                            *ngIf="!toUsername.value && !to_email_list.length && is_submitted"
                            class="mat-mdc-form-field-error mat-mdc-form-field-bottom-align"
                        >
                            Recipient email is required
                        </mat-error> -->
                    </ng-container>


                        <div class="d-flex to-mail-wrap mb-5">
                            <mat-chip-listbox>
                                <mat-chip *ngFor="let cc of cc_email_list; let i = index">
                                    {{cc}}
                                    <button matChipRemove (click)="removeCCEmail(i)">
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip>
                            </mat-chip-listbox>
                            <!-- <div role="alert" class="alert alert-dark d-flex 
                                    justify-content-space-between 
                                    align-items-center
                                    to-mail-div" *ngFor="let cc of cc_email_list; let i = index">
                                {{cc}}
                                <button type="button" (click)="removeCCEmail(i)" aria-label="Close"
                                    class="close bg-transparent p-0 border-none">
                                    <i class="ri-close-line"></i>
                                </button>
                            </div> -->
                        </div>

                        <div class="tagus-form-group without-icon">
                            <mat-form-field appearance="fill">
                                <mat-label>Cc</mat-label>
                                <input matInput formControlName="cc" (keydown.enter)="addCCEmail($event); false">
                                <mat-error *ngIf="email_form.get('cc').hasError('email')">
                                    Invalid Email
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="d-flex to-mail-wrap mb-5">
                            <mat-chip-listbox>
                                <mat-chip *ngFor="let bcc of bcc_email_list; let i = index">
                                    {{bcc}}
                                    <button matChipRemove (click)="removeBCCEmail(i)">
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip>
                            </mat-chip-listbox>
                            <!-- <div role="alert" class="alert alert-dark d-flex 
                                    justify-content-space-between 
                                    align-items-center
                                    to-mail-div" *ngFor="let bcc of bcc_email_list; let i = index">
                                {{bcc}}
                                <button type="button" (click)="removeBCCEmail(i)" aria-label="Close"
                                    class="close bg-transparent p-0 border-none text-black">
                                    <i class="ri-close-line"></i>
                                </button>
                            </div> -->
                        </div>

                        <div class="tagus-form-group without-icon">
                            <mat-form-field appearance="fill">
                                <mat-label>Bcc</mat-label>
                                <input matInput formControlName="bcc" (keydown.enter)="addBCCEmail($event); false">
                                <mat-error *ngIf="email_form.get('bcc').hasError('email')">
                                    Invalid Email
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- <div class="tagus-form-group without-icon">
                            <mat-form-field appearance="fill">
                                <mat-label>Subject</mat-label>
                                <input matInput formControlName="subject">
                                <mat-error *ngIf="email_form.get('subject').hasError('required')">
                                    Subject is required
                                </mat-error>
                            </mat-form-field>
                        </div> -->

                        <div class="tagus-form-group mb-20">
                            <div class="NgxEditor__Wrapper">
                                <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                                <ngx-editor [editor]="editor" name="html" [disabled]="false" [placeholder]=""
                                    formControlName="html">
                                </ngx-editor>
                            </div>
                            <mat-error *ngIf="is_submitted && email_form.get('html').hasError('required')">
                                Please type comment
                            </mat-error>
                        </div>

                        <div class="tagus-form-group">
                            <input type="file" style="display: none;" #open_file multiple
                                (change)="selectFiles($event)">
                            <mat-form-field appearance="fill">
                                <i class="ri-attachment-line"></i>
                                <input matInput placeholder="Choose File" (click)="open_file.click()">
                            </mat-form-field>
                        </div>

                        <div class="w-100 d-flex flex-wrap">
                            <div class="alert alert-secondary d-flex 
                                        justify-content-space-between 
                                        align-items-center me-5" role="alert"
                                *ngFor="let attachment of upload_files; index as i">
                                {{attachment.name | slice:0:20}}
                                <button type="button" class="close bg-transparent p-0 border-none" data-dismiss="alert"
                                    aria-label="Close" (click)="removeDoc(i)">
                                    <i class="ri-close-line"></i>
                                </button>
                            </div>
                        </div>
                    </span>

                </ng-container>
            </mat-card-content>
        </mat-card>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="border-t-1" *ngIf="email_form.value.from">
        <div class="btn-box">
            <button type="submit" mat-flat-button class="tagus">Send</button>
            <!-- <button mat-flat-button color="warn">Discard</button> -->
        </div>
    </mat-dialog-actions>
</form>